module.exports = "<div id=\"{{ctrl.mapId}}\" style=\"height:560px;width:100%\"></div>\r\n"